import type {
  IAuthenticationMethod,
  IFetchEnrolledKeysCriteria,
  IPublicKeyInfo,
  TAuthenticationMethod,
} from "@mne-authentication/api";
import {
  fetchAuthMethods,
  fetchAuthMethodsForUser,
  fetchAvailableAuthMethods,
  fetchEnrolledKeys,
} from "@mne-authentication/api";
import type { IResultstash } from "@mne-core/api";

import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";
import { handleResponse } from "@mnemonic/redux-utils";

import type { IBaseApiParams, TMetaOpts } from "./baseApi";
import { baseApi } from "./baseApi";

const methodsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchAvailableAuthMethod: build.query<IResultstash<TAuthenticationMethod[]>, { metaOpts?: TMetaOpts }>({
      queryFn: ({ metaOpts }) =>
        handleResponse(fetchAvailableAuthMethods({ apiUrl: ArgusUtils.getApiUrl() }), metaOpts),
    }),
    fetchAuthenticationMethodsForUser: build.query<
      IResultstash<IAuthenticationMethod[]>,
      { userId: number; metaOpts?: TMetaOpts }
    >({
      queryFn: ({ userId, metaOpts }) =>
        handleResponse(
          fetchAuthMethodsForUser(userId, {
            apiUrl: ArgusUtils.getApiUrl(),
            sessionKey: metaOpts?.sessionKey as unknown as string,
          }),
          metaOpts,
        ),
    }),
    fetchAuthenticationMethodsForCurrentSession: build.query<
      IResultstash<IAuthenticationMethod[]>,
      { metaOpts?: TMetaOpts }
    >({
      queryFn: (metaOpts) => handleResponse(fetchAuthMethods({ apiUrl: ArgusUtils.getApiUrl() }), metaOpts),
    }),
    fetchSignatureKeys: build.query<
      IResultstash<{ keys: IPublicKeyInfo[] }>,
      IBaseApiParams<IFetchEnrolledKeysCriteria>
    >({
      queryFn: ({ criteria, metaOpts }) => {
        return handleResponse(
          fetchEnrolledKeys(
            { ...criteria },
            { apiUrl: ArgusUtils.getApiUrl(), sessionKey: metaOpts?.sessionKey as unknown as string },
          ),
        );
      },
    }),
  }),
});

export const {
  useFetchAvailableAuthMethodQuery,
  useFetchSignatureKeysQuery,
  useFetchAuthenticationMethodsForUserQuery,
  useFetchAuthenticationMethodsForCurrentSessionQuery,
} = methodsApi;

export default methodsApi;
